module.exports = __webpack_public_path__ + "static/img/damoxingAi.11cf4fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/damoxingAi.png
// module id = kYoL
// module chunks = 44